import { getMask } from './get-mask';

import { CountryCode, InputMask, PhoneMask, PhoneMaskCode } from 'src/constants';

export const getPhoneMask = getMask((value) => (str, index) => {
  const regexp = /\d/;
  let isTextBlack = /[\d+]/.test(str);

  if ((str === '(' || str === '-') && regexp.test(value[index + 1])) {
    isTextBlack = true;
  }

  if ((str === ')' || str === '-') && regexp.test(value[index - 1])) {
    isTextBlack = true;
  }

  return {
    isTextBlack,
    str,
  };
});

export const getCountryPhoneMasks = (countryCode: CountryCode) => {
  const countryPhoneMask = PhoneMask[countryCode.toUpperCase() as PhoneMaskCode] ?? InputMask.PHONE;

  return Array.isArray(countryPhoneMask) ? countryPhoneMask : [countryPhoneMask];
};

export const removeSymbolsFromPhoneMask = (mask: string) => mask.replace(/[+()\s-]/g, '');

export const getCountryPhoneMask = (countryCode: CountryCode) => {
  const allMasks = getCountryPhoneMasks(countryCode);
  return allMasks
    .reduce((lastMask, currentMask) =>
      removeSymbolsFromPhoneMask(lastMask).length > removeSymbolsFromPhoneMask(currentMask).length
        ? lastMask
        : currentMask
    )
    .replace(allMasks.length > 1 ? /[#\d]/g : /#/g, '9');
};

export const parseCountryPhone = (phoneWithCode: string) => {
  const [, code, phone = ''] = phoneWithCode.match(/^(\+\d+)\s?(.*)/) || ['', '', phoneWithCode];
  return {
    code,
    phone,
  };
};
